"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var PusherService_1 = __importDefault(require("@/functions/PusherService"));
var IntegrationState = /** @class */ (function () {
    function IntegrationState(integration) {
        var _this = this;
        this.statsLoadedHandler = [];
        this.jobListChangeHandler = [];
        this.dynamicResourcePromises = {};
        this.integration = integration;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        PusherService_1.default.bind("integration", this.integration.id, function (data) { return _this.handleJobStateMessage(data); });
    }
    IntegrationState.prototype.loadStatistics = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.statsLoad) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.statsLoad];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        this.statsLoad = new Promise(function (resolve) {
                            var params = {
                                pagination: { page: 1, perPage: 5 },
                                sort: { field: "id", order: "ASC" },
                                filter: {}
                            };
                            (0, AjaxProvider_1.default)("/api")
                                .getList("app-integrations/".concat(_this.integration.id, "/statistics"), params)
                                .then(function (response) {
                                _this.stats = response.data;
                                _this.statsLoad = undefined;
                                for (var i in _this.statsLoadedHandler) {
                                    _this.statsLoadedHandler[i]();
                                }
                                resolve();
                            });
                        });
                        return [4 /*yield*/, this.statsLoad];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IntegrationState.prototype.onStatsLoadedChanged = function (statsLoadedHandler) {
        this.statsLoadedHandler.push(statsLoadedHandler);
        return this;
    };
    IntegrationState.prototype.getDynamicResources = function (script, resource) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.dynamicResourcePromises[script]) {
                    this.dynamicResourcePromises[script] = {};
                }
                if (this.dynamicResourcePromises[script] && this.dynamicResourcePromises[script][resource]) {
                    return [2 /*return*/, this.dynamicResourcePromises[script][resource]];
                }
                params = {
                    pagination: { page: 1, perPage: 5 },
                    sort: { field: "id", order: "ASC" },
                    filter: {}
                };
                this.dynamicResourcePromises[script][resource] = new Promise(function (resolve) {
                    (0, AjaxProvider_1.default)("/api")
                        .getList("app-integrations/".concat(_this.integration.id, "/resources/").concat(script), params)
                        .then(function (response) {
                        delete _this.dynamicResourcePromises[script][resource];
                        resolve(response.data);
                    });
                });
                return [2 /*return*/, this.dynamicResourcePromises[script][resource]];
            });
        });
    };
    IntegrationState.prototype.getStatistics = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.stats === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadStatistics()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, this.stats];
                }
            });
        });
    };
    IntegrationState.prototype.loadAllScriptJobs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, _loop_1, this_1, script;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.jobs !== undefined) {
                            return [2 /*return*/];
                        }
                        if (!(this.initLoad !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(this.initLoad)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        this.initLoad = [];
                        params = {
                            pagination: { page: 1, perPage: 5 },
                            sort: { field: "id", order: "ASC" },
                            filter: {}
                        };
                        _loop_1 = function (script) {
                            this_1.initLoad.push(new Promise(function (resolve) {
                                (0, AjaxProvider_1.default)("/api")
                                    .getList("app-integrations/".concat(_this.integration.id, "/jobs/").concat(script), params)
                                    .then(function (response) {
                                    resolve({
                                        script: script,
                                        data: response.data,
                                    });
                                });
                            }));
                        };
                        this_1 = this;
                        for (script in this.integration.definition.scripts) {
                            _loop_1(script);
                        }
                        Promise.all(this.initLoad).then(function (values) {
                            _this.jobs = {};
                            _this.jobById = {};
                            for (var i in values) {
                                _this.jobs[values[i].script] = [];
                                for (var n in values[i].data) {
                                    _this.jobs[values[i].script].push(_this.hydrateJobLog(values[i].data[n]));
                                }
                                _this.jobs[values[i].script].sort(function (a, b) { return a.created_at > b.created_at ? -1 : (a.created_at < b.created_at ? 1 : 0); });
                                for (var n in _this.jobs[values[i].script]) {
                                    _this.jobById[_this.jobs[values[i].script][n].id] = _this.jobs[values[i].script][n];
                                }
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    IntegrationState.prototype.loadScriptJob = function (script, id) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var params = { id: id };
                        (0, AjaxProvider_1.default)("/api")
                            .getOne("app-integrations/".concat(_this.integration.id, "/jobs/").concat(script), params)
                            .then(function (response) {
                            if (!_this.jobs[script]) {
                                _this.jobs[script] = [];
                            }
                            var job = _this.hydrateJobLog(response.data);
                            job.logs = job.logs ? job.logs : [];
                            _this.jobs[script] = _this.jobs[script].filter(function (a) { return a.id !== job.id; });
                            _this.jobs[script].push(job);
                            _this.jobs[script].sort(function (a, b) { return a.created_at > b.created_at ? -1 : (a.created_at < b.created_at ? 1 : 0); });
                            _this.jobById[response.data.id] = response.data;
                            resolve(job);
                        });
                    })];
            });
        });
    };
    IntegrationState.prototype.getScriptJobs = function (identifier, count) {
        if (count === void 0) { count = 5; }
        return __awaiter(this, void 0, void 0, function () {
            var tmp, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.jobs === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadAllScriptJobs()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.jobs[identifier]) {
                            tmp = [];
                            for (key in this.jobs[identifier]) {
                                tmp.push(this.jobs[identifier][key]);
                                if (tmp.length >= count) {
                                    break;
                                }
                            }
                            return [2 /*return*/, tmp];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    IntegrationState.prototype.getIntegrationJobs = function (count) {
        if (count === void 0) { count = 5; }
        return __awaiter(this, void 0, void 0, function () {
            var tmp, script, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.jobs === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadAllScriptJobs()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        tmp = [];
                        for (script in this.jobs) {
                            for (i in this.jobs[script]) {
                                tmp.push(this.jobs[script][i]);
                            }
                        }
                        tmp.sort(function (a, b) { return a.created_at > b.created_at ? -1 : (a.created_at < b.created_at ? 1 : 0); });
                        return [2 /*return*/, tmp.splice(0, Math.min(count, tmp.length))];
                }
            });
        });
    };
    IntegrationState.prototype.onJobListChanged = function (jobListChangeHandler) {
        this.jobListChangeHandler.push(jobListChangeHandler);
        return this;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationState.prototype.handleJobStateMessage = function (data) {
        var _this = this;
        switch (data.type) {
            case "event":
                switch (data.message.event) {
                    case "stats-updated":
                        this.loadStatistics();
                        break;
                }
                break;
            case "job-state":
                if (this.jobById !== undefined) {
                    if (data.message.status === 0 || data.message.status >= 6) {
                        this.loadScriptJob(data.message.script, data.message.id).then(function () {
                            for (var i in _this.jobListChangeHandler) {
                                _this.jobListChangeHandler[i]();
                            }
                        });
                    }
                }
                break;
            default:
                break;
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IntegrationState.prototype.hydrateJobLog = function (data) {
        var _a;
        return {
            id: data.id,
            integration_id: this.integration.id,
            resource: data.resource,
            logs: (_a = data.logs) === null || _a === void 0 ? void 0 : _a.map(function (text) {
                if (text) {
                    var matchTS = text.match(/^\[([a-z0-9\\/:\-+\s]+)\]/gi);
                    if (matchTS && matchTS[0]) {
                        var msg = {
                            timestamp: new Date("".concat(text.substring(1, 12), " ").concat(text.substring(13, 21), " ").concat(text.substring(22, 27))),
                            verbose: 1,
                            silent: false,
                            line: text.substring(matchTS[0].length).trim()
                        };
                        var matchMeta = msg.line.match(/^\[([0-9:]+)(s)?\]:/gi);
                        if (matchMeta && matchMeta[0]) {
                            msg.line = msg.line.substring(matchMeta[0].length).trimEnd();
                            var jobMeta = matchMeta[0].substring(1, matchMeta[0].length - 2).split(":");
                            if (jobMeta && jobMeta.length > 0) {
                                msg.verbose = parseInt(jobMeta[0]);
                                if (jobMeta.length > 1) {
                                    msg.silent = parseInt(jobMeta[1]) > 0;
                                }
                            }
                        }
                        return msg;
                    }
                }
                else {
                    return undefined;
                }
            }).filter(function (entry) { return entry !== undefined; }),
            exit_code: data.exit_code,
            exit_message: data.exit_message,
            ended_at: data.ended_at ? new Date(data.ended_at) : undefined,
            has_result: data.has_result,
            has_failure_result: data.has_failure_result,
            created_at: new Date(data.created_at),
        };
    };
    return IntegrationState;
}());
exports.default = IntegrationState;
